import React from 'react';
import { Link } from 'react-router-dom';
import './team.scss';

function TeamStyle1(props) {
  console.log('Props : ', props);
  return (
    <div className="team" style={{ border: '1px solid #ddd' }}>
      <div className="team-img mt-2">
        <img
          src={props.image}
          alt=""
          style={{ width: '100%', height: '250px' }}
          className="img-fluid  "
        />
      </div>
      <div className="team-info mb-2">
        <Link
          className="team-name"
          to={{ pathname: `/team-details/${props.id}` }}
        >
          {props.name}
        </Link>
        <p>
          <b>{props.role}</b>
        </p>
        <p>{props.position}</p>
        <ul className="list-unstyled">
          {props.list.map((list, index) => (
            <li key={index}>
              <Link target="_blank" to={list.url}>
                <i className={list.icon}></i>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default TeamStyle1;
